import React, { useContext, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppContext from "context/Context";
import classNames from "classnames";
import NavbarTop from "modules/navbar/top/NavbarTop";
import NavbarVertical from "modules/navbar/vertical/NavbarVertical";
import secureLocalStorage from "react-secure-storage";
import ReminderClockOut from "modules/all_authentication_pop_ups/clock_out_reminder/ReminderClockOut";
import YesterdayClockOutWarning from "modules/all_authentication_pop_ups/clock_out_warning/YesterdayClockOutWarning";
import { userCheckedInOut } from "modules/attendence_leave_tracker/api";
import moment from "moment";
import ApprovalPopUpForManager from "modules/all_authentication_pop_ups/approval_reminder_popup_for_managers/ApprovalPopUpForManager";
import LoggedInToday from "modules/all_authentication_pop_ups/logged_in_popup/LoggedInToday";
import { LOCAL_STORAGE_CONFIG, LOGGED_THE_USER_IN_KEY, userHouseConfig } from "config";
const {HOUSE, SHIFT, IS_FIRST_LOGIN, IS_NOT_CLOCKED_OUT_YESTERDAY, LOGGED_THE_USER_IN} = LOCAL_STORAGE_CONFIG;
import ActivityTracker from "modules/all_authentication_pop_ups/ActivityTracker/ActivityTracker";


const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');

  const {
    config: { navbarPosition },
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleWFHUpdate = (isWFH) => {
    const now = moment();
    const today = moment().format('DD-MM-YYYY');
    const eightAM = moment().startOf('day').add(8, 'hours');
    const sixPM = moment().startOf('day').add(18, 'hours');

    const makeUserClockIn = () => {
      try {
        userCheckedInOut({ isLoginRequest: true, 'source': 'WEB', isWFH });
        secureLocalStorage.setItem('logged_the_user_in', today);
      } catch (error) {
        console.log('error', error);
      }
    };

    if (now.isAfter(eightAM) && now.isBefore(sixPM) && userHouseConfig.includes(HOUSE)) {
      if(IS_FIRST_LOGIN || LOGGED_THE_USER_IN !== today){
        makeUserClockIn();
      }
    } else if(LOGGED_THE_USER_IN && userHouseConfig.includes(HOUSE)){
      secureLocalStorage.removeItem(LOGGED_THE_USER_IN_KEY);
    }
  };

  return (
    <div className={"container-fluid"}>
      {(navbarPosition === "vertical" || navbarPosition === "combo") && (
        <NavbarVertical />
      )}
      <div className={classNames("content", { "pb-0": isKanban })}>
       <ActivityTracker />
        <NavbarTop />
        {IS_FIRST_LOGIN && userHouseConfig.includes(HOUSE) ? <LoggedInToday firstLogin={ true } onWFHUpdate={handleWFHUpdate} /> : <></>}
        <ApprovalPopUpForManager /> 
        <ReminderClockOut shiftTime={SHIFT} />
        {IS_NOT_CLOCKED_OUT_YESTERDAY && IS_FIRST_LOGIN && userHouseConfig.includes(HOUSE) ? <YesterdayClockOutWarning didClockOutYesterday={IS_NOT_CLOCKED_OUT_YESTERDAY} /> : <></>}
        <Outlet />
      </div>
    </div>
  );
};
export default MainLayout;
